import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { selectors } from 'builder/modules/interview/interviewModule'
import { behaviourType } from 'builder/modules/interview/types'
import { StartContent } from './components/StartContent/StartContent'
import { StartAuthWrapper } from './styles'
export interface Params {
  behaviour?: behaviourType
}
export const LoggedUserStartView = () => {
  const { behaviour }: Params = useParams()
  const jobTitleId = useSelector(selectors.jobTitleId)
  const jobTitleReady = useSelector(selectors.jobTitleReady)
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!jobTitleReady) {
      return
    }
    if (jobTitleId !== null) {
      return navigate('/interview-preparation/dashboard')
    }
    setReady(true)
    trackInternalEvent('visit_test_interview', {
      label: 'interview_prep',
      parameter: behaviour || 'default',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobTitleReady])

  if (!ready) {
    return null
  }

  return (
    <StartAuthWrapper>
      <StartContent />
    </StartAuthWrapper>
  )
}
